import { render, staticRenderFns } from "./PazienteDeviceListComponent.vue?vue&type=template&id=d966cecc"
import script from "./PazienteDeviceListComponent.vue?vue&type=script&lang=js"
export * from "./PazienteDeviceListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports